// Shared metadata for the admin-side agent-template UI.
//
// The template_type values MUST match the Literal in
// backend/schemas/agent_template/enums.py. Pydantic will reject unknown
// values, so this list is effectively the authoritative picker.

export const TEMPLATE_TYPES = [
  { value: 'broker_remote_sales', label: 'Broker Remote Sales' },
  { value: 'local_retail_appointment', label: 'Local Retail — Appointment' },
  { value: 'trade_follow_up', label: 'Trade Follow-Up' },
  { value: 'powersports_seasonal', label: 'Powersports Seasonal' },
  { value: 'old_lead_reactivation', label: 'Old Lead Reactivation' },
];

export const SECTION_FIELDS = [
  // Free-text sections
  { key: 'role_section', label: 'Role', type: 'text' },
  { key: 'goal_section', label: 'Goal', type: 'text' },
  // Rule lists (one per line in the UI)
  { key: 'opening_rules', label: 'Opening rules', type: 'list' },
  { key: 'qualification_path', label: 'Qualification path', type: 'list' },
  { key: 'objection_handling', label: 'Objection handling', type: 'list' },
  { key: 'transfer_rules', label: 'Transfer rules', type: 'list' },
  { key: 'callback_rules', label: 'Callback rules', type: 'list' },
  { key: 'voicemail_rules', label: 'Voicemail rules', type: 'list' },
  { key: 'end_call_rules', label: 'End-of-call rules', type: 'list' },
  { key: 'tool_usage_rules', label: 'Tool usage', type: 'list' },
  { key: 'restricted_claim_rules', label: 'Restricted claims (never say)', type: 'list' },
  // Free text again
  { key: 'compliance_section', label: 'Compliance section', type: 'text' },
  { key: 'prompt_injection_protection', label: 'Prompt-injection protection', type: 'text' },
];

// Status → pill colour (Tailwind classes).
export const STATUS_BADGE = {
  draft: 'bg-yellow-100 text-yellow-800',
  published: 'bg-green-100 text-green-800',
  archived: 'bg-gray-200 text-gray-700',
};
